module.exports = __webpack_public_path__ + "img/268VIcon.ce5555da.png";